<template>
  <div id="account">
    <form action="/web/checkout" method="POST">
      <input name="authenticity_token" type="hidden" :value="token">
      <div class="container">
        <div class="font-14 font-medium mt-3 mb-2">Alamat pengiriman</div>
        <div class="font-12 color-slate mb-3">
          {{ winner.display_name }} ({{ winner.phone }})<br/>
          {{ winner.receiving_address }}<br/>
          {{ winner.receiving_regency.name }}, {{ winner.receiving_province.name }}
        </div>
      </div>
      <hr class="is-bigger my-0">
      <div class="container">
        <div class="font-14 font-medium mt-3">{{ user.display_name }}</div>
        <hr>
        <div class="history-info-header align-items-start">
          <div class="history-info-image">
            <a href="#">
              <img :src="product.cover_image_url" class="img-fluid" alt="icon">
            </a>
          </div>
          <div class="history-info-name">
            <div class="history-info-title">
              <a href="#">{{ product.title }}</a>
            </div>
            <div v-show="product.weight" class="history-info-sub">
                Berat: {{ product.weight }} kilogram
            </div>
            <div class="history-info-sub mb-2">{{ user.shipping_province_name }}</div>
            <div class="font-medium">{{ product.latest_bid_amount | currency }}</div>
          </div>
        </div>
      </div>
      <hr class="is-bigger">
      <div class="container">
        <div class="font-14 font-medium mt-3 mb-2">Pengiriman</div>
        <div class="box">
          <div class="d-flex align-items-center justify-content-between">
            <div v-if="shippingCost">
              <div class="font-14 font-medium">{{ shippingCost.senderable_display_name }} ({{ shippingCost.senderable_type }})</div>
              <div class="font-12 color-slate">{{ shippingCost.cost_amount | currency }}</div>
            </div>
            <div v-else>
              <div class="font-14 font-medium">Pilih metode pengiriman</div>
            </div>
            <div id="shipment">
              <button type="button" class="btn btn-sm btn-outline-secondary" data-toggle="modal" data-target="#shippingMethod">
                Pilih
              </button>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="container mb-3">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <div class="font-14 font-medium">Total</div>
          <div class="font-14 font-medium">{{ totalPayment | currency }}</div>
        </div>
        <div class="d-flex align-items-center justify-content-between mb-2">
          <div class="font-12 color-slate">Harga</div>
          <div class="font-12 color-slate">{{ product.latest_bid_amount | currency }}</div>
        </div>
        <div class="d-flex align-items-center justify-content-between mb-2">
          <div class="font-12 color-slate">Ongkos kirim</div>
          <div class="font-12 color-slate">{{ estimationShippingCost | currency }}</div>
        </div>
        <div class="d-flex align-items-center justify-content-between mb-2">
          <div class="font-12 color-slate">Biaya transaksi</div>
          <div class="font-12 color-slate">{{ transactionFee | currency }}</div>
        </div>
      </div>

      <hr class="is-bigger">

      <div class="container">
        <button class="btn btn-primary btn-block" :disabled="!isValid">Pilih pembayaran</button>
      </div>
      <input name="estimation_shipping_cost_id_hidden" type="hidden" :value="estimationShippingCostId">
    </form>

    <div class="modal fade" id="shippingMethod" tabindex="-1" aria-labelledby="shippingMethodLabel" aria-hidden="true">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="shippingMethodLabel">Pilih Pengiriman</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="modal-sort">
              <label :for="`ship-${index}`" v-for="(shippingCost, index) in shippingCosts" :key="index">
                <span>
                  <div class="font-medium font-14 mb-2">{{ shippingCost.senderable_display_name }} ({{ shippingCost.senderable_type }})</div>
                  <p class="color-slate font-12 mb-2">{{ shippingCost.note }}</p>
                  <div class="font-medium font-14 color-primary">{{ shippingCost.cost_amount | currency }}</div>
                </span>
                <span>
                  <input type="radio" name="estimation_shipping_cost_id" hidden="hidden" :id="`ship-${index}`" @change="setShippingCost(shippingCost)" :value="shippingCost.id">
                  <img src="~icon-checkmark.svg" width="24">
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'checkout-form',
  props: {
    token: {
      type: String,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    winner: {
      type: Object,
      required: true
    },
    shippingCosts: {
      type: Array,
      required: true
    },
    transactionFee: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      estimationShippingCostId: null,
      shippingCost: null
    }
  },
  computed: {
    estimationShippingCost () {
      let cost = this.shippingCosts.find(sp => sp.id === this.estimationShippingCostId)

      return (typeof cost === 'undefined') ? 0 : cost.cost_amount
    },
    totalPayment() {
      return parseInt(this.estimationShippingCost) + parseInt(this.product.latest_bid_amount) + parseInt(this.transactionFee)
    },
    isValid() {
      return parseInt(this.estimationShippingCost) > 0
    }
  },
  methods: {
    setShippingCost(shippingCost) {
      this.shippingCost = shippingCost
      this.estimationShippingCostId = shippingCost.id

      $('#shippingMethod').modal('hide')
    }
  }
}
</script>